// extracted by mini-css-extract-plugin
export var teaserAllButton = "component-module--teaserAllButton--735a6";
export var teaserBottomLayout = "component-module--teaserBottomLayout--56bb8";
export var teaserContainer = "component-module--teaserContainer--d2ab9";
export var teaserHeading = "component-module--teaserHeading--3c601";
export var teaserSection = "component-module--teaserSection--3d9bf";